import { Component,OnInit, Output,OnChanges, ElementRef, EventEmitter, Input,ChangeDetectionStrategy ,SimpleChange  } from '@angular/core';
import { SelectItem } from 'primeng/api/selectitem';
import { ActivatedRoute } from '@angular/router';
import { FacilityService  } from 'src/app/services';
import { FormControl } from '@angular/forms';
@Component({
  selector: 'bart-keysearch',
  templateUrl: './keysearch.component.html',
  styleUrls: ['./keysearch.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush 
})
export class KeysearchComponent implements OnInit,OnChanges  {
  Name = new FormControl('');
  displayValidationPopup: boolean;
  // @Input() textBox : string;
  @Output() btnKeywordSearchClicked = new EventEmitter();  
  @Input() strkeyWord:string;
  changeLog: string[] = [];


  constructor(private route: ActivatedRoute, private _facilityService:FacilityService) { }
  ngOnInit() {
    this.displayValidationPopup=false;
   
  }

  public resetTextBox(){
        this.strkeyWord = "";
  }
  ngOnChanges(changes: {[propKey: string]: SimpleChange}) {
    // create header using child_id
    let log: string[] = [];
    for (let propName in changes) {
      let changedProp = changes[propName];
      let to = JSON.stringify(changedProp.currentValue);
      if (changedProp.isFirstChange()) {
        log.push(`Initial value of ${propName} set to ${to}`);
      } else {
        let from = JSON.stringify(changedProp.previousValue);
        log.push(`${propName} changed from ${from} to ${to}`);
      }
    }
    this.changeLog.push(log.join(', '));
  }

  public getKeyword()
  {
    //this.strkeyWord=document.getElementById('txtKeyword').Value;
    this.strkeyWord=(<HTMLInputElement>document.getElementById('txtKeyword')).value;
    this.btnKeywordSearchClicked.emit(this.strkeyWord);
  }
}
